import { useEffect, useMemo, useState } from "react";
import { BiErrorCircle } from "react-icons/bi";
import { ImDownload } from "react-icons/im";
import HabilidadesIndividuais from "../../components/HabilidadesIndividuais";
import Layout from "../../components/Layout"
import Loader from "../../components/Loader";
import { useCsvData } from "../../utils/mocks/csv/useCsvData";
import { useDownloadPdf } from "../../hooks/useDownloadPdf";

import "./styles.css";
import { Navigate, useSearchParams } from "react-router-dom";
import { useCooldownAction } from "../../hooks/useCooldownAction";

const Result = () => {
    const [searchParams] = useSearchParams()
    const sessionAbilities = useMemo( () => [
        Number(searchParams.get("comunicativa")) || 0,
        Number(searchParams.get("social")) || 0,
        Number(searchParams.get("motora")) || 0,
    ], [searchParams])

    const { loading: csvLoading, filter: csvDataFiltered  } = useCsvData(sessionAbilities);
    const { isLoading, download } = useDownloadPdf()
    const [selected, setSelected] = useState([]);
    const { execute, isPending } = useCooldownAction(() => download(selected), 1000)


    if(searchParams.size <= 0 && sessionAbilities.every(it => it === 0) ){
        return <Navigate to={"/filter"} replace/>
    }

    const isDisabled = isLoading || isPending

    const toggleSelected = (activity) => {
        const alreadySelected = selected.some((s) => s.id === activity.id);

        if (alreadySelected) {
            setSelected(selected.filter((s) => s.id !== activity.id));
        } else {
            setSelected([...selected, activity]);
        }
    };

    const loadData = () => {

        if (csvLoading) {
            return <Loader size={40}/>;
        }

        if (csvDataFiltered && csvDataFiltered.length > 0) {
            return csvDataFiltered.map((item, index) => {
                let backgroundColor = selected.some(s => s.id === item.id)
                    ? "#1dab7d"
                    : "white";
                
                return (
                    <div className="item-resultado" key={item.id}>
                        <HabilidadesIndividuais
                            onClick={() => toggleSelected(item)}
                            data={item}
                            backgroundColor={backgroundColor}
                        />
                    </div>
                );
            });
        }

        return (
            <div className="item-error">
                <BiErrorCircle/> Houve um erro ao processar sua solicitação ou o arquivo está vazio.
            </div>
        );
    };

    return (
        <Layout
            title={`Atividades \nSugeridas`}
            titleColor="#1dab7d"
            description='Selecione dentre as atividades sugeridas quais deseja indicar para a criança. Clique em "Download" para obter a ficha das atividades lúdicas em .PDF'
            children={<div className="result-container">{loadData()}</div>}
            button={{
                text: !isDisabled ? "Download" : 'Carregando...',
                icon: isDisabled || <ImDownload/>,
                clickHandle: (_) => {
                    if(selected.length === 0){
                        alert("Selecione pelo menos uma atividade")
                        return
                    }
                    execute()
                }
            }}
            backButton={"/filter"}
        />
    );
};

export default Result;